export const NOTIFICATIONS_COUNT_KEY = 'notifications_count';
export const PAGE_SIZE_KEY = 'page_size';
